import React, {useState} from "react"
import GenericModal from "@irati/ui/src/GenericModal"
import FormattedMessage from "@irati/utils/lang"
import RequestPointsForm from "./Form"
import RequestPointsSuccess from "./Success"
import {H3} from "@irati/ui/src/Typography"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {PointsRequest} from "@irati/types"
import Flex from "@irati/ui/src/Flex"

interface Props {
  show: boolean
  onHide: () => void
}

enum ModalTypes {
  FORM,
  SUCCESS
}

const RequestPointsModal = (props: Props) => {
  const {show, onHide} = props
  const [modalType, setModalType] = useState(ModalTypes.FORM)
  const [pointsRequest, setPointsRequest] = useState<PointsRequest>()
  const closeModal = () => {
    setModalType(ModalTypes.FORM)
    setPointsRequest()
    onHide()
  }
  const onDone = (request: PointsRequest) => {
    setPointsRequest(request)
    setModalType(ModalTypes.SUCCESS)
  }
  const newRequest = () => {
    setModalType(ModalTypes.FORM)
    setPointsRequest(undefined)
  }
  return (
    <GenericModal show={show} onHide={closeModal} customWidth={600} hideActions>
      <H3 marginBottom={3}>
        {ModalTypes.FORM === modalType && <FormattedMessage id="wallet.reward.budget.rewardWallet.cta.requestPoints" />}
        {ModalTypes.SUCCESS === modalType && (
          <Flex gap={1} alignItems="center">
            <Icon icon={IconTypes.circleCheckFill} />
            <FormattedMessage id="wallet.reward.budget.rewardWallet.title.requestPointsSuccess" />
          </Flex>
        )}
      </H3>
      {ModalTypes.FORM === modalType && <RequestPointsForm onDone={onDone} />}
      {ModalTypes.SUCCESS === modalType && pointsRequest && (
        <RequestPointsSuccess onSendNewRequest={newRequest} pointsRequest={pointsRequest} />
      )}
    </GenericModal>
  )
}
export default RequestPointsModal
